// import 'react-app-polyfill/ie11';
// import React from 'react';
// import ReactDOM from 'react-dom';
// import { HashRouter } from 'react-router-dom';
// import AppWrapper from './AppWrapper';
// //import reportWebVitals from './reportWebVitals';

// ReactDOM.render(
//   <HashRouter>
//     <AppWrapper />
//   </HashRouter>,
//   document.getElementById('root')
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// //reportWebVitals();

import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
// import AppWrapper from './AppWrapper';
import AppWithAuth from './App';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

Amplify.configure(awsExports);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <Authenticator.Provider>
      <AppWithAuth />
    </Authenticator.Provider>
  </HashRouter>
);


